import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default class FeaturedArtist {
	constructor(el) {
		this.el = el;

        const mm = gsap.matchMedia();

        this.items = [];

        this.el.querySelectorAll('[data-artist]').forEach((el) => {
            this.items.push(new featuredArtistItem(el))
        });

        this.heading = this.el.querySelector('[data-artist-heading]');
        this.container = this.el.querySelector('[data-artist-container]');

		mm.add({
			isMobile: `(max-width: 991px)`,
			isDesktop: `(min-width: 992px)`,
			reduceMotion: '(prefers-reduced-motion: reduce)',
		}, (context) => {
			this.context = context;

			if(this.context.conditions.isDesktop) {

                this.items.forEach(item => {
                    item.init();
                })
            }
		});
    }
}


class featuredArtistItem {
    constructor(el) {
        this.el = el;
        this.triggerEl = this.el.querySelector('[data-artist-meta]');

        if(this.el.dataset.artist == "first") {
            this.isFirst = true;
        } else {
            this.isFirst = false;
        }

        if(this.el.dataset.artist == "last") {
            this.isLast = true;
        } else {
            this.isLast = false;
        }
    }

    init() {

        let start = "top 320";
        let end = "bottom 320";

        if(this.el.dataset.artist == "y-as") {
            end = "bottom 370";
        }

        if(this.isLast) {
            end = "bottom bottom-=220"
        }

        this.st = ScrollTrigger.create({
            trigger: this.el,
            pin: this.triggerEl,
            start: start,
            end: end,
            onEnter: () => {
                this.triggerEl.classList.add('is-visible');
            },
            onEnterBack: () => {
                this.triggerEl.classList.add('is-visible');
            },
            onLeave: () => {
                if(!this.isLast) {
                    this.triggerEl.classList.remove('is-visible');
                }
            },
            onLeaveBack: () => {
                if(!this.isFirst) {
                    this.triggerEl.classList.remove('is-visible');
                }
            }
        });
    }

    destroy() {
        this.st.kill();
    }
}


